import React, { useEffect, useState, useMemo } from "react";
import {
  Box,
  Typography,
} from "@mui/material";


function SetupPlansPackages() {
  

  return (
    <Box className="page-container admin-container">
     SetupPlansPackages
    </Box>
  );
}

export default SetupPlansPackages;